import { PeriodType } from '../../services/LimitsService.schemas';

export const PERIOD_TYPES: PeriodType[] = ['Daily', 'Weekly', 'Monthly'];
